import React, { useState } from 'react';
import { MdAccessTime, MdEmail, MdPhone, MdRateReview, MdLocationOn } from 'react-icons/md';
import { FiMapPin } from 'react-icons/fi';
import withAnimation from '../../../hooks/withAnimation';
import { send } from 'emailjs-com';
import ContactSection from '../../ContactComponents/ContactSection';
import { clinicLocation, emailContact, reviewPage } from '../../../config';

const AreasWeServe = () => {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber:'',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const serviceID = 'service_qbr67d9';
    const templateID = 'template_udrryil';
    const userID = '0a9fFxfpocJmq1SvN';

    send(serviceID, templateID, formData, userID)
      .then((response) => {
        setStatusMessage('Message sent successfully!');
      })
      .catch((err) => {
        setStatusMessage('Failed to send the message.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="bg-background py-12">
      <div className="container mx-auto px-6 lg:px-20">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-primary">Get in Touch</h2>
          <p className="text-lg text-gray-600 mt-4">
            We'd love to hear from you. Please fill out the form or contact us using the details below.
          </p>
        </div>

        {/* Contact Form & Details */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white p-8 rounded-lg shadow-lg">
            {statusMessage && (
              <p className={`text-center mb-4 ${statusMessage.includes('successfully') ? 'text-green-600' : 'text-red-600'}`}>
                {statusMessage}
              </p>
            )}
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="name"
                  className="block text-lg font-semibold text-gray-700"
                >
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full mt-2 px-4 py-3 border border-gray-300 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition duration-200"
                  placeholder="Your Full Name"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block text-lg font-semibold text-gray-700"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full mt-2 px-4 py-3 border border-gray-300 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition duration-200"
                  placeholder="Your Email Address"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="phoneNumber"
                  className="block text-lg font-semibold text-gray-700"
                >
                  Phone Number
                </label>
                <input
                  
                  id="phoneNumber"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="w-full mt-2 px-4 py-3 border border-gray-300 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition duration-200"
                  placeholder="Your Phone Number"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="message"
                  className="block text-lg font-semibold text-gray-700"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="6"
                  className="w-full mt-2 px-4 py-3 border border-gray-300 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition duration-200"
                  placeholder="Your Message"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className={`w-full bg-primary hover:bg-secondary text-white py-4 rounded-lg font-semibold transition duration-200 ${
                  loading ? 'opacity-50 cursor-not-allowed' : ''
                }`}
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>

          {/* Contact Details */}
          <div className="bg-gradient-to-br from-darkBackground to-primary text-white p-8 rounded-lg shadow-lg space-y-6">
            <h2 className="text-2xl md:text-4xl font-bold">Conklin Health Centre</h2>
            <div className="space-y-4">
            <a href={clinicLocation} target='_blank' className="flex items-center">
                <MdLocationOn className="mr-2 h-6 w-6" />
                <span>360 Conklin Rd Unit A2, Brantford, ON N3T 0N5</span>
              </a>
              <a href={"tel:+1 (226) 368-1309"}  className="flex items-center">
                <MdPhone className="mr-2 h-6 w-6" />
                <span>Call +1 (226) 368-1309</span>
              </a>
              <a href={`mailto:${emailContact}`}className="flex items-center">
                <MdEmail className="mr-2 h-6 w-6" />
                <span>info@conklinphysiochiroplus.com</span>
              </a>
             
              <a href={reviewPage} className="flex items-center">
                <MdRateReview className="mr-2 h-6 w-6" />
                <span>Read Our Reviews</span>
              </a>
              <div className="flex items-start">
                <MdAccessTime className="mr-2 h-6 w-6" />
                <div>
                <span>Open Hours</span>
                <div>Monday: 10AM – 7PM</div>
                <div>Tuesday: 10AM – 7PM</div>
                <div>Wednesday: 11AM – 4PM</div>
                <div>Thursday: 10AM – 7PM</div>
                <div>Friday: 10AM – 7PM</div>
                <div>Saturday: 9AM – 3PM</div>
                <div>Sunday: Closed</div>
              </div>
              </div>
            </div>

            {/* Embedded Google Map */}
            <div className="w-full h-64 overflow-hidden rounded-lg">
              <iframe
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2519.343389488154!2d-123.36570808424613!3d48.4593113792516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548f0ddee2179f23%3A0xc9b92b9804887602!2s3960%20Quadra%20St%20%23106%2C%20Victoria%2C%20BC%20V8X%204A3%2C%20Canada!5e0!3m2!1sen!2sus!4v1663625205679!5m2!1sen!2sus"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAnimation(AreasWeServe);
